import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Typography } from '@material-ui/core'
import HotswapTabsLayout from './components/hotswap-tabs-layout'
import HotSwapTabOrder from './components/hotswap-tab-order'
import {
    urlToSearchState,
    useSyncUrlState
} from 'web/src/utils/hooks/useSyncUrlState'
import * as actions from './actions'
import { useHotswapFilters } from '../root/hooks/use-hotswap-filters'
import { useLocation } from 'react-router-dom'
import HotSwapTabCapacity from './components/hotswap-tab-capacity'

export default function HotSwapAdmin() {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const dispatch = useDispatch()
    const loc = useLocation()

    const [filters, d] = useHotswapFilters(urlToSearchState(loc))
    useSyncUrlState(filters)

    useEffect(() => {
        dispatch(actions.getLocationsAdminRequest(filters))
    }, [filters])

    const onSearch = searchValue => {
        d({ type: 'search', value: searchValue.trim() })
    }

    const onSortBy = sort_by => {
        d({ type: 'sort', sort_by })
    }

    const tabs = [
        {
            label: 'Orders',
            content: (
                <HotSwapTabOrder
                    filters={filters}
                    onSearch={onSearch}
                    onSortBy={onSortBy}
                />
            )
        },
        { label: 'Capacity', content: <HotSwapTabCapacity /> }
    ]

    return (
        <>
            <div className={classes.mainWrapper}>
                <Box className={classes.headingSection}>
                    <Typography className={classes.heading}>
                        {locale.hotSwap.hotSwapOrders}
                    </Typography>
                </Box>
                <div className={classes.wrapper}>
                    <HotswapTabsLayout
                        tabs={tabs}
                        component={<HotSwapTabOrder />}
                    />
                </div>
            </div>
        </>
    )
}

const useStyles = makeStyles(() => ({
    headingSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
        padding: '32px 0'
    },
    heading: { fontSize: '24.5px', lineHeight: '31px', fontWeight: 600 },
    wrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    mainWrapper: {
        display: 'initial'
    }
}))
